import React from "react"
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import { Order } from "pages/admin/Orders"
import { useTranslation } from "react-i18next"

interface OrderActionMenuProps {
  order: Order
  acceptHandler: (order: Order) => void
  rejectHandler: (order: Order) => void
  viewDetailsHandler: (order: Order) => void
}

const OrderActionMenu: React.FC<OrderActionMenuProps> = ({
  order,
  acceptHandler,
  rejectHandler,
  viewDetailsHandler,
}) => {
  const { t } = useTranslation()

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-vertical font-size-18"></i>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem onClick={() => acceptHandler(order)}>
          <span className="text-success">{t("common_accept")}</span>
        </DropdownItem>
        <DropdownItem onClick={() => rejectHandler(order)}>
          <span className="text-danger">{t("common_reject")}</span>
        </DropdownItem>
        <DropdownItem onClick={() => viewDetailsHandler(order)}>
          <span className="">{t("common_viewDetails")}</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default OrderActionMenu